export default function ($http) {
    return function (page = 1, exportId) {
        return $http.get('/api/importfiles/history', {
            params: {
                page,
                exportId
            }
        })
        .then(response => response.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/data-import-export/services/import/getImportList.js